import Dexie, { Table } from "dexie"
import { HistoryInterface } from "helpers/history/type"
import { DbHistory } from "./type"

export class HistoryRepository {
    private table: Table<DbHistory>

    constructor(db: Dexie) {
        this.table = db.table("history")
    }

    public async add(history: Omit<HistoryInterface, "id">) {
        const dbHistory: Omit<DbHistory, "id"> = {
            date: history.date,
            waste_type: history.wasteType,
        }

        // We do not need the id here, since it is created by Dexie
        await this.table.add(dbHistory as DbHistory)
    }

    private mapDbToModel(data: DbHistory): HistoryInterface {
        return {
            id: data.id,
            wasteType: data.waste_type,
            date: data.date,
        }
    }

    public async list(
        limit: number = 20,
        offset: number = 0,
    ): Promise<HistoryInterface[]> {
        const data = await this.table.offset(offset).limit(limit).sortBy("date")
        const reversedData = data.reverse()

        return reversedData.map(this.mapDbToModel)
    }

    public async listBetweenDate(start: Date, end: Date): Promise<HistoryInterface[]> {
        const data = await this.table
            .where("date")
            .between(start, end, true, false)
            .sortBy("date")

        return data.reverse().map(this.mapDbToModel)
    }

    public async deleteAll(): Promise<void> {
        await this.table.clear()
    }

    public async delete(id: number): Promise<void> {
        await this.table.where("id").equals(id).delete()
    }
}
